export default __webpack_public_path__ + "static/media/28d-card-vertical.14ec7de7.png";